import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any, isTerminal: boolean, isAddress: boolean) => {
  const {
    response: { contact, profile, terminals, address },
  } = data
  const residentialContact = contact?.find((item: any) => item.contactType === 'Residential')
  const bussinessContact = contact?.find((item: any) => item.contactType === 'Business') ?? residentialContact
  let mobile: string = bussinessContact?.mobileNumber ?? ''
  mobile = mobile.length > 10 ? mobile.slice(-10) : mobile
  const firstName = bussinessContact?.firstName
  const lastName = bussinessContact?.lastName
  const name = `${bussinessContact?.firstName}${
    bussinessContact?.middleName ? ` ${bussinessContact?.middleName}` : ''
  }${bussinessContact?.lastName ? ` ${bussinessContact?.lastName}` : ''}`
  const businessLegalName = profile?.businessLegalName ?? ''
  let terminalID
  if (isTerminal) {
    const terminalData = terminals?.find((item: any) => item.isDefault)
    terminalID = terminalData?.terminalID ?? ''
  }
  let addressString, pincode
  if (isAddress) {
    const addressData = address?.find((item: any) => item.addressType === 'Business')
    addressString = `${addressData?.flatNumber ? `${addressData?.flatNumber} ` : ''}${addressData?.buildingName}${
      addressData?.street ? `, ${addressData?.street}` : ''
    }${addressData?.subLocality ? `, ${addressData?.subLocality}` : ''}${
      addressData?.landMark ? `, ${addressData?.landMark}` : ''
    }${addressData?.areaLocality ? `, ${addressData?.areaLocality}` : ''}${
      addressData?.district ? `, ${addressData?.district}` : ''
    }${addressData?.state ? `, ${addressData?.state}` : ''}${addressData?.pinCode ? `, ${addressData?.pinCode}` : ''}`
    pincode = addressData?.pinCode
  }
  return {
    mobile,
    name,
    businessLegalName,
    terminalId: terminalID,
    address: addressString,
    pincode,
    firstName,
    lastName,
  }
}

const getMerchantRequestBody = (mid: string, isTerminal: boolean, isAddress: boolean) => {
  const outputDomains = ['PROFILE', 'CONTACT']
  if (isTerminal) {
    outputDomains.push('TERMINAL')
  }
  if (isAddress) {
    outputDomains.push('ADDRESSES')
  }
  return {
    inputFilter: {
      mid: mid,
    },
    outputDomains,
    configParams: {
      mediaType: 'application/json',
    },
  }
}

const searchMerchant = (mid: string, tokens: any, isTerminal: boolean = false, isAddress: boolean = false) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.searchMerchant,
    body: getMerchantRequestBody(mid, isTerminal, isAddress),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return responseParser(data.data, isTerminal, isAddress)
    } else {
      throw data
    }
  })
}

export { searchMerchant }
